import React from 'react'
import { asJSON, asJSONSafe } from '../../functions'
import { toUIDate, toUIDateTime } from '../../functions/dateHelpers';
import { joinStrings } from '../../functions/stringHelpers';
import { formatDate2, formatDateAsDate } from '../../functions/formatters';

export const mappingSchema = [
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameAddressPlaceOfWork', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            if (!_) {
                return _;
            }
            return joinStrings(_.addressLine, _.fullName);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAny', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullNameAddressPlaceOfWork', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'theAddress', //the name of field from targetObject
        targetNumber: '115', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyOfTheSubject', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'taIfAny', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAny', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameOfTheSubject', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAvailable', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameInitialsOfThePatientAddressReceiptNumberOrganizationBuilding', //the name of field from targetObject
        targetNumber: '222', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicPatient', //the name of field from targetObject
        targetNumber: '221', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnyIinOfTheSubject', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.fullName, _.identityNumber);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnyAgeOfTheInspectedPerson', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.fullName, formatDateAsDate(_.yearOfBirth));
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'theAddress', //the name of field from targetObject
        targetNumber: '221', // the number of target itself (can be empty)        
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'nameAddressPlaceOfWork', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.fullName, _.addressLine, _.placeOfWorkOrEducation);
        }
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicSubjectX000D', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicOfTheSubject', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'ofTheSubject', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnyOfTheInspectedPersonIfAny', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicOfTheInspectedPerson', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.birthDate', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'yearOfBirth', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = formatDateAsDate(_);
            return d;
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'address', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'residenceAddress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.placeOfWorkOrEducation', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'placeOfWorkPosition', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'placeOfWorkAddress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.placeOfWorkOrEducation, _.addressLine);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'workOrStudyAddress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.placeOfWorkOrEducation, _.addressLine);
        }
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateTime.sampling', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },    
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateTime.alreadyTaken', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },  
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateTime.theTeam', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = formatDateAsDate(_);
            return d;
        },  
    }, 
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'date.theObtainedSample', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    }, 
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchStartDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateTime.theBeginningOfTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },  
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchStartDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'date.theBeginningOfTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },  
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'sampleDeliveryDate', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateMonthYear.theSampleWasObtained', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },    
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateTime.gettingSamples', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },   
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateAndTimeOfSampling', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = formatDateAsDate(_);
            return d;
        },  
    },   
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateMonthYear.deliveryOfTheSample', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },  
    },
    //
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'lastNameFirstNamePatronymicSignatureOfThePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureOfThePersonConductingTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateSignature', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'resultDateSignature', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnySignatureOfThePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'theSpecialistWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureSurnameNamePatronymicIfAnyOfThePersonConductingTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnyPositionSignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicSignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'conclusionOnTheSuitabilityOfTheCultureMedium', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureOfABacteriologist', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'researchResult.dateOfCompletionOfTheStudySurnameNamePatronymicSignatureOfThePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '131', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureOfTheResearcher', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signature', //the name of field from targetObject
        targetNumber: '127', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'nameAndSignatureOfThePersonWhoPerformedTheCalibration', //the name of field from targetObject
        targetNumber: '125', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'theResultsOfTheStudyTheDateOfCompletionOfTheStudyTheYearThePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '136', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'lastNameFirstName', //the name of field from targetObject
        targetNumber: '142', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'measured', //the name of field from targetObject
        targetNumber: '270', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'measurementsCarriedOut', //the name of field from targetObject
        targetNumber: '269', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicAndSignatureOfTheSpecialist', //the name of field from targetObject
        targetNumber: '180', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureOfTheLaboratoryDoctorAnd', //the name of field from targetObject
        targetNumber: '177', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameOfTheExecutorIfAnyFullNameInCashPerformer', //the name of field from targetObject
        targetNumber: '140', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyAndSignatureOfTheSpecialistsWhoCarriedOutTheMeasurements', //the name of field from targetObject
        targetNumber: '272', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicOfTheSpecialistsWhoCarriedOutTheMeasurement', //the name of field from targetObject
        targetNumber: '245', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnySignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '118', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnySignatureOfTheResearcher', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'thePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '163', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateMonthYearOfCompletionOfTheStudySurnameNameSignatureOfThePersonConductingTheStudy', //the name of field from targetObject
        targetNumber: '120', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicOfTheSurveyingSpecialists', //the name of field from targetObject
        targetNumber: '175', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureOfThePersonWhoReceivedTheProtocol', //the name of field from targetObject
        targetNumber: '174', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnySignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signingSurnameNamePatronymicOfThePersonConductingTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureOfTheHeadOfTheLaboratory', //the name of field from targetObject
        targetNumber: '130', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnySignatureOfTheResearcher', //the name of field from targetObject
        targetNumber: '122', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'theResult', //the name of field from targetObject
        targetNumber: '248', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnyPositionSignatureOfThePersonConductingTheResearch', //the name of field from targetObject
        targetNumber: '217', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'lastNameFirstNamePatronymicIfAnySignatureOfTheResearcher', //the name of field from targetObject
        targetNumber: '225', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'namePatronymicIfAnyPositionAndSignatureOfThePersonConductingTheStudy', //the name of field from targetObject
        targetNumber: '185', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnySignatureOfThePersonConductingTheResearch', //the name of field from targetObject
        targetNumber: '139', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyPositionAndSignatureOfThePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '137', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signature', //the name of field from targetObject
        targetNumber: '126', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signature', //the name of field from targetObject
        targetNumber: '124', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signature', //the name of field from targetObject
        targetNumber: '128', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signature', //the name of field from targetObject
        targetNumber: '123', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'responsible.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signature', //the name of field from targetObject
        targetNumber: '113', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyPositionSignatureOfThePersonWhoConductedTheControl', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.fullName, _.position?.name);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'ofASpecialist', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.fullName, _.position?.name);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyPositionOfThePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnySignatureOfTheSpecialistWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '237', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyAndSignatureOfTheResearcher', //the name of field from targetObject
        targetNumber: '235', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'thePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '234', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyPositionAndSignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '227', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'completionOfTheStudy', //the name of field from targetObject
        targetNumber: '110', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateMonthYearOfStudyCompletion', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = formatDateAsDate(_);
            return d;
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'analysisEndDate', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = formatDateAsDate(_);
            return d;
        },
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateMonthYearOfStudyCompletion', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'studyEndDate', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchStartDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'date.theStudyBegan', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'date.theStudyIsCompleted', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureSurnameNamePatronymicIfAnyPositionOfThePersonConductingTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'lastNameFirstNamePatronymicIfAnyPositionSignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnyPositionOfThePersonSignatureWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnyPositionSignatureOfTheSpecialistWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicPositionAndSignatureOfThePersonConductingTheResearch', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'responsibleForBrakerage', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'theResultOfTheStudyTheDateOfCompletionOfTheStudyFullNameIfAnySignatureOfThePersonWhoConductedTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicIfAnyPositionSignatureOfTheResearcher', //the name of field from targetObject
        targetNumber: '218', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'lastNameFirstNamePatronymicIfAnyPositionAndSignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
        targetNumber: '228', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'signatureOfTheResearcherFullNameIfAnyPosition', //the name of field from targetObject
        targetNumber: '203', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'performer.fullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'fullNameIfAnySignatureOfTheResearcher', //the name of field from targetObject
        targetNumber: '167', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'organizationPlaceOfSampling', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'nameOfThePersonWhoDeliveredTheSampleIfAnyNameOfTheInstitutionThatSentItNameOfOrganizationFullNameIfAvailableSignatureOfTheSampleReceived', //the name of field from targetObject
        targetNumber: '144', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'theNameOfTheSendingInstitution', //the name of field from targetObject
        targetNumber: '137', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateOfTheSurvey', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },      
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateOfTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },      
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchStartDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateMonthYearOfTheStartOfTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },      
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'dateMonthYearOfTheEndOfTheStudy', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            const d = toUIDate(_);
            return d;
        },      
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'ndForTestMethod', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {         
            if (!_) {
                return _;
            }
            
            let items = asJSONSafe(_);
            if (items.length)
                items = items.map(_ => _.name);
            return joinStrings(items);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'ndNormOfProduct', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {         
            if (!_) {
                return _;
            }
            
            let items = asJSONSafe(_);
            if (items.length)
                items = items.map(_ => _.name);
            return joinStrings(items);
        }
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetObject', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'nameAndLocationOfTheObject', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.name, _.addressLine);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'closeContactFullName', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'surnameNamePatronymicOfficialSignatureOfThePersonWhoBroughtTheBlood', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'diagnosis', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'diagnosisMainSymptoms', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'diagnosisFrequencyOfExamination', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'result', // result or protocol
        targetMember: 'diagnosisDateOfIllness', //the name of field from targetObject
        targetNumber: '216', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'nd_selection_method', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            if (!_) {
                return _;
            }

            let items = asJSONSafe(_);
            if (items.length)
                items = items.map(_ => _.name);
            return joinStrings(items);
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document2', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            if (!_) {
                return _;
            }
            let items = asJSONSafe(_);
            if (items.length)
                items = items.map(_ => _.name);
            return joinStrings(items);
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'probeStatus', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'first_or_repeated', //the name of field from targetObject
        targetNumber: '29', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            switch (_) {
                case "первичный":
                    return "первичное";
                case "повторный":
                    return "повторное";
            } 
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'probeStatus', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'type_of_research', //the name of field from targetObject
        targetNumber: '80', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            switch (_) {
                case "первичный":
                    return "первичное";
                case "повторный":
                    return "повторное";
            } 
        },
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'probeStatus', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'first_or_repeated', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            switch (_) {
                case "первичный":
                    return "первичное";
                case "повторный":
                    return "повторное";
            } 
        },
        // 287
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'probeStatus', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'first_or_repeated', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            switch (_) {
                case "первичный":
                    return "Первичный";
                case "повторный":
                    return "Повторный";
            } 
        },
        // 287
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'probeStatus', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'first_or_repeated', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            switch (_) {
                case "первичный":
                    return "первичное";
                case "повторный":
                    return "повторное";
            } 
        },
        // 287
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'med_organization', //the name of field from targetObject
        targetNumber: '29', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_directed', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'med_organization', //the name of field from targetObject
        targetNumber: '61', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'patient_fullName', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'examinatee_full_name', //the name of field from targetObject
        targetNumber: '42', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'age_adress', //the name of field from targetObject
        targetNumber: '80', // the number of target itself (can be empty)
        sourceMemberMap: _ => {
            return joinStrings(_.yearsOld, _.addressLine);
        }
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.placeOrWorkOrEducation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'place_of_work_adress', //the name of field from targetObject
        targetNumber: '80', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.yearsOld', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'patient_yearsOld', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.identityNumber', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'patient_identity', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'patient_address', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.placeOrWorkOrEducation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'patient_workPlace', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'patient_diagnosis', //the name of field from targetObject
        targetNumber: '54', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'diagnosis', //the name of field from targetObject
        targetNumber: '61', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'diagnosis', //the name of field from targetObject
        targetNumber: '82', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'diagnosisObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'diagnosis', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
        // 286
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'adress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'organization_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_obtaining_place', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarding_organizations', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchMaterial', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchMaterial', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'probe_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'place_of_selection', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_org_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'applicant_full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.phoneNumber', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'contact_number', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.identityNumber', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'iin', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.yearsOld', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'age', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.placeOfWorkOrEducation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'place_of_work', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.placeOfWorkOrEducation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'work_place', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'home_adress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'selection_date', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_obtaining_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'probe_delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'nd_on_research_method', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'research_on_nd', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_type', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '70', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'research_on_nd_done', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '61', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'measurement_results', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '45', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'research_of_samples_to_nd_compliance', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    //
    //
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_selection', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_measurements', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'transportationCondition.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'transport_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleCollectedFullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'material_forwarder', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'storageCondition.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'storage_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'purposeOfSelection.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchPurpose', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researcherStatus1', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'purposeOfSelection.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'examination_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    ///////////acts
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'object.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'adress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'selectionDateTime.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'selection_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'deliveryDateTime.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'data.selectionDateTime.value', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        sourceMemberMap: _ => {
            const d = toUIDateTime(_);
            return d;
       }, 
        targetMember: 'sampleSelectionTime', //the name of field from targetObject
   //     targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'data.deliveryDateTime.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            const d = toUIDateTime(_);
            return d;
       },
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sampleDeliveryTime', //the name of field from targetObject
   //     targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'nd_on_research_method', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_selection', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_measurements', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'object.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'organization_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filial', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filial', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filialId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filialId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filialDivision', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filialDivision', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filialDivisionId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filialDivisionId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilialDivisionId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilialDivisionId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilialDivision', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilialDivision', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilialId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilialId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilial', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilial', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'selectionPlace.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_obtaining_place', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'selectionPlace.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'place_of_selection', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'samplingPurpose.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'samplingPurpose.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goals', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'transportationCondition.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'transport_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'storageCondition.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'storage_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'preservationMethod.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'water_conservation_methods', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
///////////results
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'number', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'registrationNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'number', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'date.registrationNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'surnameNamePatronymicPatientMedicalRecordNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'thePersonBeingInspected', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'surnameNamePatronymicIfAnyOfTheSubject', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'lastNameFirstNamePatronymicIfAnySignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
    targetNumber: '172', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'fullNameIfAnySignatureOfThePersonWhoConductedTheResearch', //the name of field from targetObject
    targetNumber: '162', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
//
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetObject.name', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'organizationSubmittingTheSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'nameOfTheSendingOrganization', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'theOrganizationThatSentTheSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.placeOfWorkOrEducation', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'placeOfWorkPosition', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'data.diagnosis', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'diagnosisDateOfIllness', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.yearsOld', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'age', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'homeAddress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'residentialAddress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchMaterial', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'testSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchMaterial', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'sampleName', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchMaterial', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'modelName', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchPurpose', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'purposeOfTheStudy', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchPurpose', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'thePurposeOfTheStudy', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researcherStatus1', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'thePurposeOfTheStudy', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchStartDateTime', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'dateOfStudy', //the name of field from targetObject
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },    
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchStartDateTime', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'date.analysisStart', //the name of field from targetObject
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },    
    targetNumber: '171', // the number of target itself (can be empty)
},
//analysisStart
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },
    targetType: 'result', // result or protocol
    targetMember: 'dateOfStudyCompletion', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },
    targetType: 'result', // result or protocol
    targetMember: 'date.endOfAnalysis', //the name of field from targetObject
    targetNumber: '171', // the number of target itself (can be empty)
},
//
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },
    targetType: 'result', // result or protocol
    targetMember: 'receiptDate', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'institutionThatSentTheSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'samplingLocation', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'samplingLocation', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
/////////////////////////resultProtocol
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'theResultsOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_results', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'researchResult', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_results', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'researchResult', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'complied_with_regulatory_doc', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'purposeOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_goal', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'purposeOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_goals', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'diagnosis', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'diagnosis', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'dateMonthYearOfTheStartOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'sample_delivery_date', //the name of field from targetObject dateMonthYearOfStudyCompletion
    targetNumber: '', // the number of target itself (can be empty)
    targetMemberType: 'date'
},
///////////////////prescriptions
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'number', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'emergencyNotificationNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'targetDate', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    sourceMemberMap: _ => {
        const d = toUIDate(_);
        return d;
   },
    targetMember: 'emergencyNotificationDate', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'targetObject', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'targetObject', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'targetObjectId', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'targetObjectId', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'standards', //the name of field from objectReferral or act
    sourceMemberMap: _ => asJSONSafe(_),
    targetType: 'objectReferral', // result or protocol
    targetMember: 'standard2', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'regulationOfCUs', //the name of field from objectReferral or act
    sourceMemberMap: _ => asJSONSafe(_),
    targetType: 'objectReferral', // result or protocol
    targetMember: 'regulationOfCU2', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
////////////////resolutions
{
    sourceType: 'resolution', // objectReferral or act
    sourceMember: 'number', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'emergencyNotificationNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
/////////////////////referrals
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'examinatee_full_name', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'diagnosis', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'diagnosis', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.yearsOld', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'age', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'adress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'adress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (sampleSentOrganizationName
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'organization_name', //the name of field from targetObject
    targetNumber: '', // the number of target itself (sampleSentOrganizationName
}
]

